import apiClient from '../axios.js';

export const batchOperationService = {
    /**
     * 查詢批次操作列表
     * @param {Object} params - 查詢參數
     * @returns {Promise<Object>} 批次操作列表
     */
    getBatchOperations: async (params = {}) => {
        const response = await apiClient.get('/batch-operations', { params });
        return response;
    },

    /**
     * 建立批次操作（預覽）
     * @param {Object} data - 批次操作資料
     * @returns {Promise<Object>} 建立的批次操作
     */
    createBatchOperation: async (data) => {
        const response = await apiClient.post('/batch-operations', data);
        return response;
    },

    /**
     * 查詢批次操作詳情
     * @param {string} batchId - 批次操作 ID
     * @returns {Promise<Object>} 批次操作詳情
     */
    getBatchOperation: async (batchId) => {
        const response = await apiClient.get(`/batch-operations/${batchId}`);
        return response;
    },

    /**
     * 執行批次操作
     * @param {string} batchId - 批次操作 ID
     * @returns {Promise<Object>} 執行結果
     */
    executeBatchOperation: async (batchId) => {
        const response = await apiClient.post(`/batch-operations/${batchId}/execute`);
        return response;
    },

    /**
     * 查詢執行明細列表
     * @param {string} batchId - 批次操作 ID
     * @param {Object} params - 查詢參數
     * @returns {Promise<Object>} 執行明細列表
     */
    getExecutionDetails: async (batchId, params = {}) => {
        const response = await apiClient.get(`/batch-operations/${batchId}/details`, { params });
        return response;
    },

    /**
     * 刪除批次操作
     * @param {string} batchId - 批次操作 ID
     * @returns {Promise<Object>} 刪除結果
     */
    deleteBatchOperation: async (batchId) => {
        const response = await apiClient.delete(`/batch-operations/${batchId}`);
        return response;
    }
};
